import { ProductCollectionResource } from '../../Types';
import SystemManagedPlaceholder from '../SystemManagedPlaceholder';
import SystemManagedIndicator from '../SystemManagedIndicator';

interface Props {
  productCollection: ProductCollectionResource;
  index: number;
}

function SystemManagedSection({ productCollection, index }: Props) {
  const { name, description, kind } = productCollection.payload;

  return (
    <div
      data-testid="system-managed-section"
      data-intercom-target="system-managed-section"
      className="mx-auto flex flex-col px-0 py-10 xl:container"
    >
      <div
        data-testid="system-managed-section-header"
        data-intercom-target="system-managed-section-header"
        className="px-6 md:px-16"
      >
        <div className="flex items-center justify-between">
          {/* Read-only title */}
          <div className="min-w-96">
            <h2 className="text-xl text-foreground">{name || `Section ${index + 1}`}</h2>
          </div>
          {/* System managed indicator instead of Add Programs button */}
          <SystemManagedIndicator />
        </div>
        {/* Read-only description */}
        {description && (
          <div className="mt-4">
            <p className="text-muted-foreground">{description}</p>
          </div>
        )}
      </div>
      <div
        data-testid="system-managed-section-body"
        data-intercom-target="system-managed-section-body"
        className="px-6 md:px-16 mt-8"
      >
        <SystemManagedPlaceholder kind={kind} />
      </div>
    </div>
  );
}

export default SystemManagedSection;
